import { useMemo, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { Form } from 'react-bootstrap';
import { InteractiveDiv } from '@Components/InteractiveEl';
import { listAdminSkills } from './google-ads-audit-admin-api';

interface AdminSkillSearchProps {
  onSelectSkill: (id: string) => void;
}

const MAX_RESULTS = 8;

export const AdminSkillSearch = ({ onSelectSkill }: AdminSkillSearchProps) => {
  const [query, setQuery] = useState('');
  const { data: skills = [] } = useQuery({
    queryKey: ['google-ads-audit-admin-skills-search'],
    queryFn: () => listAdminSkills()
  });

  const matches = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return [];
    return skills
      .filter(s => s.label.toLowerCase().includes(q) || s.key.toLowerCase().includes(q))
      .slice(0, MAX_RESULTS);
  }, [query, skills]);

  return (
    <div className='google-ads-audit-admin-skill-search'>
      <Form.Control
        placeholder='Search skills by label or key…'
        value={query}
        onChange={e => setQuery(e.target.value)}
      />
      {matches.length > 0 && (
        <div className='google-ads-audit-admin-skill-search-results'>
          {matches.map(skill => (
            <InteractiveDiv
              key={skill.id}
              onClick={() => {
                setQuery('');
                onSelectSkill(skill.id);
              }}
            >
              <span>{skill.label}</span>
              <span className='google-ads-audit-admin-skill-search-key'>{skill.key}</span>
            </InteractiveDiv>
          ))}
        </div>
      )}
    </div>
  );
};
